//import React components
import PropTypes from "prop-types";
import {Button} from "reactstrap";
import SideControlInfo from "./components/SideControlInfo.js";
import SideControlActions from "./components/SideControlActions.js";
import {useRef} from "react";
import {useDetectOutSideClick} from "../../../functions/Triggers/eventListners.js";
import {useAppState} from "../../../context/state.js";

//import components


//Props settings for sideControl
SideControl.propTypes = {}

SideControl.defaultProps = {

}

export default function SideControl ({state, sideControlRef}) {
    const [open] = state;
    const [appState, setAppState] = useAppState();

    return (
        <>
            <div className={open ? "sideControl--open" : "sideControl"}>
                <div className={"sideControl_container"}>
                    <SideControlInfo/>
                    <SideControlActions/>
                </div>
            </div>
        </>
    )
}
